'use strict';

(function(global) {

  /**
   * Абстрактный класс действий над документом.
   *
   * @since 5.7.0
   */
  class BaseActions {

    /**
     * Настройки предпросмотра.
     *
     * @property settings
     * @return {BaseDocumentPreviewSettings} Настройки предпросмотра.
     */
    get settings() {
      return this._settings;
    }

    /**
     * Инициализация атрибутов.
     *
     * @method _initAttributes
     * @protected
     */
    _initAttributes(context) {
      if (context.actionUrl) {
        this._fullscreenUrl = this._createFullscreenUrl(context.actionUrl, context.objectsData, context.selectedObj);
      }
      this._jFrame = $('#contentContainer');
      this._jFrameContents = this._jFrame.contents();
      this._isIpad = (WA.ENV.device.model && WA.ENV.device.model.toLowerCase() === 'ipad');
    }

    /**
     * Сместить предпросмотр в центр.
     *
     * @method movePreview
     */
    movePreview() {}

    /**
     * Установка ширины контейнера после масштабирования и изменения размера окна.
     *
     * @method onResize
     */
    onResize() {}

    /**
     * Сменить масштаб.
     *
     * @method setScale
     * @param {string} key масштаб
     */
    setScale(key) {
      this.settings.previewScale = key;
    }

    /**
     * Установить текущий масштаб в выпадайке масштаба.
     *
     * @method _setScaleValueInDropdown
     * @param {string} key Масштаб
     * @return {boolean} TRUE - если масштаб был установлен в выпадайке, иначе - FALSE.
     */
    _setScaleValueInDropdown(key) {
      const dropDownList = $('#scaleinp').data('DropDownListInstance');
      if (dropDownList && dropDownList.getValue() !== key) {
        dropDownList.setValue(key, undefined, false);
        return true;
      }
      return false;
    }

    /**
     * Создать url для страницы альтернативного (полноэкранного/обычного) режима.
     *
     * @method setScale
     * @param {string} url адрес страницы альтернативного режима
     * @param {object} selectedObj
     * @param {object} objectsData
     */
    _createFullscreenUrl(url, selectedObj, objectsData) {
      // Если в полноэкранном режиме указан адрес возврата, то нужно перейти по нему.
      let requestParams = {};
      if (WA.getLocation() === 'documentpreview') {
        const currentUrl = new WA.URL();
        const returnUrl = currentUrl.getParam('returnUrl');
        if (returnUrl) {
          return returnUrl;
        }
      }

      let concatSymbol = url.includes('?') ? '&' : '?';

      requestParams = Object.assign(requestParams, {
        previewPageNum: selectedObj.pageNumber,
        previewScale: selectedObj.scale,
        previewAllowCopyText: selectedObj.allowCopyText,
      });

      if (objectsData) {
        const objectData = objectsData[selectedObj.id] || {};
        requestParams = Object.assign({}, objectData.requestParams, requestParams);
      }

      // Добавим параметры к url
      url += concatSymbol + $.param(requestParams);

      return url;
    }

    /**
     * Переключить в полноэкранный режим.
     *
     * @method toggleFullscreen
     */
    toggleFullscreen() {
      window.top.location = this._fullscreenUrl;
    }

    /**
     * Напечатать документ.
     *
     * @method printDocFromPreview
     */
    printDocFromPreview() {
      const iframe = window.frames.contentContainer;
      iframe.focus();
      //для ie
      if (iframe.document) {
        if (Core.preview.document.dataType.isSpreadsheet && iframe.document.frames.length > 1) {
          iframe.document.frames[0].document.execCommand('print', false, null);
        } else {
          iframe.document.execCommand('print', false, null);
        }
      } else {
        if (Core.preview.document.dataType.isSpreadsheet && iframe.contentWindow.frames.length > 1) {
          const printFrame = iframe.contentWindow.frames[0];
          printFrame.focus();
          printFrame.print();
        } else {
          iframe.contentWindow.print();
        }
      }
    }

  }

  global.BaseActions = BaseActions;

})(window.Core.preview);
